export const PROBLEM_WIDTH = 762;
export const NARROW_PROBLEM_WIDTH = 320;
export const MAX_MULTI_LINE_WIDTH = 500;
export const STUDENT_PROBLEM_BACKCOLOR = '#f8f8f8';
